/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

export default {
  data () {
    return {
      selectLoading: false,
    }
  },
  methods: {
    selectRemoteMethod (query, request, callback, params) {
      if (query !== '') {
        this.selectLoading = true
        setTimeout(() => {
          request({keyword: query, ...params}).then((response) => {
            callback(response.data)
          }).finally(() => {
            this.selectLoading = false
          })
        }, 200)
      } else {
        this.rawCustomerItems = []
      }
    },
  },
}



// WEBPACK FOOTER //
// ./core/mixins/selectRemote.js